import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/rodrigolemos/meistrari/identity-provider/packages/auth-dashboard/layouts/default.vue").then(m => m.default || m))
}